<template>
    <div id="PrivacyPolicy" class="page" >
        <appModal ref="appModalRef" :countries="DBCountries"></appModal>
        <appHeader bgColor="blue" @headerMenuClicked="menuClicked" page="privacy"></appHeader>
        <div class="main">
            <div class="main_inner">
                <section class="main_section">
                    <div class="section_content">
                        <h2 class="text_subtitle">-</h2>
                        <h1 class="title_page text_title2">
                            PRIVACY POLICY AND TERMS OF USE
                        </h1>
                        <div class="text_subtitle" style="margin-top: 40px;">
                            WHAT INFORMATION DOES THE WEBSITE COLLECT?
                        </div>
                        <!--
                        <p class="text_p" style="margin-top: 24px;">
                            <span class="bolder">Personal information</span><br />
                            Personal data is the information you provide us when you register for an event or subscribe to our newsletter. If you register for an event, you will be asked for information that helps to identify you, such as your name and email address. We only collect the necessary data for the purpose at hand, and we only store the data you provide directly to us. Under no circumstances will your personal information be passed on to third parties. If you contact us via the contact email address, we will keep track of these emails.
                        </p>
                        -->
                        <p class="text_p" style="margin-top: 24px;">
                            <span class="bolder">Non-personally identifiable information</span><br />
                            <u style="margin-top: 20px; display: inline-block;">Cookies:</u><br />
                            A cookie is a small bit of code stored on your computer’s hard drive. When visiting our website, some information may be stored in the “Cookies” files installed in your computer, tablet or mobile phone. This information is gathered so that we can better understand the usage of its sites, and improve and develop them. None of this information can be used to identify individual site visitors, the cookie only identifies the browser of your device. The cookie file allows the transmitter to recognize the terminal every time it accesses the digital content containing cookies from the same transmitter, and can only be read by it.<br /><br />
                            <u>Technical cookies:</u><br />
                            They are necessary for browsing our website and in particular allow you to recognize you, to report your visit on different pages and thus improve your browsing comfort by adapting the presentation of the site to the display preferences of your terminal, especially regarding the language used.<br /><br />
                            <u>Audience cookies:</u>
                            It measure the audience of the content and topics on our site, in order to evaluate and better organize them. These cookies produce only anonymous statistics and attendance volumes, excluding any individual information. Cookies are activated. Uncheck this box to disable them.
                        </p>
                        <div class="text_subtitle" style="margin-top: 40px;">
                            “LINKED SITES” OR HYPERLINKS
                        </div>
                        <p class="text_p" style="margin-top: 24px;">
                            Some pages of our website may contain external links to other websites, allowing certain content of our site to be linked to similar thematic content hosted on other websites (Hyperlinks). We do not accept any responsibility for the privacy practices of these linked websites or any external company that may collect this data. We encourage you to consult and read the privacy policy of each of these sites to understand how the data collected is used and protected.
                        </p>

                        <div class="text_subtitle" style="margin-top: 40px;">
                            WHAT ARE MY PRIVACY RIGHTS?
                        </div>
                        <p class="text_p" style="margin-top: 24px;">
                            You have the right to access, modify, correct and delete your personal data at any time (art. 34 of the French Data protection act). To do so, contact us at: <a href="mailto:contact.atlas@taxobservatory.eu">contact.atlas@taxobservatory.eu</a>
                        </p>
                        <p class="text_p" style="margin-top: 24px;">
                            At any time, you can unsubscribe from our emails, by following the “unsubscribe” instructions near the bottom of the email. You can also email us at: <a href="mailto:contact.atlas@taxobservatory.eu">contact.atlas@taxobservatory.eu</a>
                        </p>

                        <!--
                        <div class="text_subtitle" style="margin-top: 40px;">
                            ANY QUESTIONS?
                        </div>
                        <p class="text_p" style="margin-top: 24px;">
                            Should you have any questions or concerns about our privacy policy and the protection of your personal data, please contact us at: <a href="mailto:dpo@taxobservatory.eu">dpo@taxobservatory.eu</a>
                        </p>
                        -->

                        <div class="text_subtitle" style="margin-top: 40px;">
                            WEB HOSTING PROVIDER:
                        </div>
                        <p class="text_p" style="margin-top: 24px;">
                            DigitalOcean<br />
                            101 Avenue of the Americas, New York 10013, United States of America<br />
                            Tél : +33 (0)8 203 203 63 / E-mail : contact@digitalocean.com<br />
                            Server location: Frankfurt, Germany
                        </p>

                        <div class="text_subtitle" style="margin-top: 40px;">
                            CONTACTS
                        </div>
                        <p class="text_p" style="margin-top: 24px;">
                            Publications coordination: Pierre Bachas</br />
                            Website coordination: Idann Gidron<br />
                            Data Protection: <a href="mailto:dpd.demandes@cnrs.fr">dpd.demandes@cnrs.fr</a>
                        </p>
                        <br /><br /><br />
                    </div>
                </section>
            </div> 
        </div>
        <appFooter></appFooter>
        <cookiesConsent></cookiesConsent>
    </div>
</template>

<script>
    import * as d3 from 'd3'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import Vue from 'vue'
    import * as UTILS from '~/commons/utils/index.js'
    import {_} from 'underscore'
    var slugify = require("underscore.string/slugify")
    var numberFormat = require('underscore.string/numberFormat')

    import appHeader from '~/components/appHeader.vue'
    import appFooter from '~/components/appFooter.vue'
    import appModal from '~/components/appModal.vue'
    import cookiesConsent from '~/components/cookiesConsent.vue'

    export default {
        components: {
            "appHeader": appHeader,
            "appFooter": appFooter,
            "appModal": appModal,
            "cookiesConsent": cookiesConsent
        },

        data: function () {
            return {
                isDataLoaded: false,
                DBCountries: [],
            }
        },

        created: function () {

        },

        mounted: function () {
            var self = this; 
                        this.loadCountriesMetadata();
        },

        methods: {
            loadCountriesMetadata: function (){
                var self = this;

                UTILS.loadCountriesCSVData().then(function (callbackDBCountries){
                    self.DBCountries = JSON.parse(JSON.stringify(callbackDBCountries.dbCountries));
                }).catch(err => {
                console.log(err);
              });
            },

            openModal: function (modalType){
                this.$refs.appModalRef.openModal(modalType);
            },

            menuClicked: function (menuType){
                this.openModal(menuType)
            },
        },

        watch: {

        }
    }

</script>

<style lang="scss">
    @import "~assets/scss/_variables.scss";
    @import "~assets/scss/_browsers.scss";

    #PrivacyPolicy .main{
        background: #fff;
        .main_section{
        
        }
    }

   
</style>


// WEBPACK FOOTER //
// pages/privacy-policy/index.vue